import { Button, InlineNotification } from "@justhome/react-ui";
import { useApplicationTranslation } from "@lib/hooks/translations";
import clsx from "clsx";
import Image from "next/image";
import { FC, MouseEventHandler } from "react";

interface ActionCardProps {
  title: string;
  list: string[];
  image: { src: string; width: number; height: number; border?: boolean };
  label: string;
  onClick: MouseEventHandler;
  className?: string;
  isLoading?: boolean;
  isError?: boolean;
  buttonTestId?: string;
}

const ActionCard: FC<ActionCardProps> = ({
  title,
  list,
  image,
  label,
  onClick,
  className,
  isError,
  isLoading,
  buttonTestId,
}) => {
  const { t } = useApplicationTranslation();

  return (
    <section
      className={clsx(
        "bg-neutral-12 rounded-m border border-neutral-50 py-m px-s m:p-2m flex flex-col",
        className,
      )}
    >
      <h2 className="text-h2 mb-3xs m:mb-3s">{title}</h2>
      <ul className="list-disc pl-3s marker:text-primary-800 mb-3s space-y-xs">
        {list.map((item) => (
          <li key={item}>{item}</li>
        ))}
      </ul>
      <div className="pb-m mt-auto">
        <Image
          src={image.src}
          alt=""
          className={clsx("mx-auto", {
            "border border-neutral-50": image.border,
          })}
          height={image.height}
          width={image.width}
        />
      </div>
      {isError && (
        <InlineNotification type="error" className="mb-s">
          {t("generic_error")}
        </InlineNotification>
      )}
      <Button
        data-testid={buttonTestId}
        isLoading={isLoading}
        className="!w-full mb-3xs m:mb-3s"
        onClick={onClick}
        size="md"
        iconEnd="Right"
      >
        {label}
      </Button>
      <p
        className="text-body-2"
        dangerouslySetInnerHTML={{ __html: t("form_consent_terms_partner") }}
      />
    </section>
  );
};

export default ActionCard;
